import React from 'react'
import injectStyles from 'react-jss'

const styles = {
  marker: {
    backgroundColor: 'black',
    height: 50,
    width: 1,
    position: 'absolute',
    top: 0,
    left: 0,
  },
}

const Marker = ({ classes, ...otherProps }) => (
  <div {...otherProps} className={classes.marker} />
)

export default injectStyles(styles)(Marker)



// WEBPACK FOOTER //
// ./src/Components/Stats/BulletChartRaw/Marker.js